// extracted by mini-css-extract-plugin
export default {"howItWorks":"HowItWorks_howItWorks__B4nCY","desktop":"HowItWorks_desktop__p-Yqf"};